import React from 'react';
import '../../../css/common/utility/Spinner.css'; 

/**
 * Spinner Component
 *
 * Purpose:
 * Displays a loading spinner while data or page content
 * is being loaded.
 *
 * Features:
 * - Shows a loading animation.
 * - Displays a "Loading..." message.
 *
 * Used In:
 * Any page or component where loading state is required.
 */
const Spinner = () => {
  return (
    // Spinner container
    <div className="spinner-container">

      {/* Loading animation */}
      <div className="loader"></div>

      {/* Loading text */}
      <p>Loading...</p>
    </div>
  );
};

export default Spinner;